import React from 'react';
import Card from 'react-bootstrap/Card';
import { Button } from 'ui';
import NoDeviceButton from '../NoDeviceButton';
import styles from '../../DeviceLinks.module.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { setButtonVariant } from 'utils/utilities';
import PropTypes from 'prop-types';

const Link = (props) => {
    const [copied, setCopied] = React.useState(false);

    if (copied) {
        setTimeout(() => setCopied(false), 2000);
    }
    return (
        <React.Fragment>
            <Card.Body style={{ padding: '24px 0px 0px' }} className={styles.body}>
                <h4 className={styles.PassportCardHeading}>Copy Link</h4>
                <p className={styles.PassportCardSubheading}>
                    Copy and open this link on your phone
                </p>

                <p className={styles.link}>{props.link}</p>
            </Card.Body>

            <Card.Footer
                style={{
                    padding: '70px 0px 0px',
                    border: 'none',
                    background: 'none',
                }}
                className="text-muted"
            >
                <CopyToClipboard text={props.link} onCopy={() => setCopied(true)}>
                    <Button
                        disabled={copied}
                        block
                        variant={setButtonVariant(props.theme?.button?.variant)}
                        className={styles.passportFooterBtn}
                    >
                        {copied ? 'Copied' : 'Copy Link'}
                    </Button>
                </CopyToClipboard>
                {!props?.isReauthenticate && (
                    <NoDeviceButton navigate={props.navigate} stopPolling={props.stopPolling} />
                )}
            </Card.Footer>
        </React.Fragment>
    );
};

Link.propTypes = {
    link: PropTypes.string,
    theme: PropTypes.object,
    navigate: PropTypes.func,
    stopPolling: PropTypes.func,
    isReauthenticate: PropTypes.bool,
};

export default Link;
